import { useEffect } from 'react';

const UmamiAnalytics = () => {
  useEffect(() => {
    // Création de l'élément script
    const script = document.createElement('script');
    script.defer = true;
    script.src = 'https://stats.coffee-beans.fr/script.js';
    script.setAttribute('data-website-id', '27f79271-cea3-44f2-943b-32eb05a71cc9');

    // Ajout du script au head du document
    document.head.appendChild(script);

    // Nettoyage lors du démontage du composant
    return () => {
      document.head.removeChild(script);
    };
  }, []); // Le tableau vide signifie que cet effet ne s'exécute qu'une fois au montage

  return null; // Ce composant ne rend rien visuellement
};

export default UmamiAnalytics;